<template>
  <div class="item">
    <dt v-if="title" class="item__title">{{ title }}</dt>
    <dd :class="{'item__data': true, 'item__data--wide': wide}">
      <div class="c-form-select -status -learning">
        <div>
          <label>
            <select
              v-model="proxyValue"
              @change="emit('change')"
              class="learningStatusSelectBox"
              :class="{ 'select-single-disabled': isDisabled }"
              tabindex="0"
              name="selectsingle"
              :disabled="isDisabled"
            >
              <option v-if=initBlank disabled value=""></option>
              <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
              >{{ option.name }}</option>
            </select>
          </label>
        </div>
      </div>
    </dd>
  </div>
</template>

<script setup lang="ts">
  import {computed} from "vue";
  import { ISelectSingleOption } from "@/consts/interfaces";

  // FIXME: options に IJ さんスタイル当てられるように変更する (select -> ul, li)
  const props = withDefaults(
    defineProps<{
      selected: number | string;
      title?: string;
      options: ISelectSingleOption[];
      wide?: boolean;
      initBlank?: boolean;
      isDisabled?: boolean;
    }>(),
    {
      title: "",
      wide: false,
      initBlank: true,
      isDisabled: false
    }
  )
  const emit = defineEmits<{
    (e: "update:selected", value: number | string): void;
    (e: "change"): void;
  }>()
  const proxyValue = computed({
    // getter
    get(){
      return props.selected
    },
    set(newValue){
      emit('update:selected', newValue)
    }
  })
</script>

<style lang="scss" scoped>
/* FIXME: リリース1向け CSS */
.learningStatusSelectBox {
  appearance: auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 0 9px 0 #cad2de;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  height: 44px;
  padding: 0 1em;
  width: calc(100% - 4px);
}
.select-single-disabled {
  pointer-events: none;
}
</style>
